import { VFC, useEffect, useCallback, useRef, useState } from "react";
import {
  Box,Text,Link,Spinner,Center,
  Modal,ModalOverlay,ModalContent,ModalHeader,ModalCloseButton,ModalBody,ModalFooter,
  Table,Tbody,Tr,Th,Td,useDisclosure,
} from "@chakra-ui/react";
import { useOpelog } from '../../../hooks/useOpelog';
import { useDocument } from "../../../hooks/useDocument";
import { DocObj, DocKindObj } from "../../../types/document";
import { PrimaryButton } from "../../atoms/button/PrimaryButton";
import { ErrorDialog } from "../../organisms/modal/ErrorDialog";

type Props = {
  setDocFlag: (flag:boolean) => void;
};

export const DocDialog: VFC<Props> = (props) => {
  const { setDocFlag } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { GetDocumentList, docList, GetDocumentURL, setDocURL, GetDocumentDownload, docURL, executing, errObj, opeErrMes } = useDocument();
  const { OutputOpelog } = useOpelog();
  const execFlag = useRef(false);
  const [ dlFlag, setDlFlag ] = useState(false);
  const [ closeFlag, setCloseFlag ] = useState(false);
  
  // オープン
  useEffect(() => {
    !isOpen && onOpen();
    // eslint-disable-next-line
  }, []);
  
  // ドキュメント一覧取得
  useEffect(() => {
    if( !execFlag.current ){
      execFlag.current = true;
      GetDocumentList();
      OutputOpelog('document_download', 'reference', '');
    }
  }, []);
  
  // DLドキュメント
  const dlDocument = useCallback((docObj:DocObj) => {
    
    OutputOpelog('document_download', docObj.documentType === 'transition' ? 'transition' : 'download', docObj.documentId);
    
    if( docObj.documentType === 'direct' ){
      window.open(docObj.documentUrl, '_blank');
      
    }else if( docObj.documentType === 'transition' ){
      window.open(docObj.documentUrl, '_blank');
    
    }else if( docObj.documentType === 'binary' ){
      setDlFlag(true);
      GetDocumentDownload(docObj.documentId,docObj.documentName);
      
    }else if( docObj.documentType === 's3' ){
      setDlFlag(true);
      setDocURL('');
      GetDocumentURL(docObj.documentId);
    }
  
  }, [GetDocumentURL,dlFlag]);
  
  // ドキュメントダウンロード
  useEffect(() => {
    if( dlFlag && docURL ){
      // console.log('ここ',dlFlag);
      window.location.href = docURL;
    }

  }, [docURL,dlFlag]);
  
  // ドキュメント一覧を閉じる
  const closeDialog = useCallback(() => {
    setDocFlag(false);
    onClose();
  }, []);
    
  // エラー時に閉じる
  useEffect(() => {
    if( closeFlag ){
      setDocFlag(false);
      onClose();
    }
  }, [closeFlag]);
  
  return (
    <>
    {(errObj || opeErrMes) && !closeFlag ? (
      <ErrorDialog errTitle="ドキュメント一覧取得" errObj={errObj} opeErrMes={opeErrMes} setCloseFlag={setCloseFlag} />
      
    ) : (
      <Modal
        isOpen={isOpen}
        onClose={closeDialog}
        motionPreset="slideInBottom"
        autoFocus={false}
        size="4xl"
        isCentered
        scrollBehavior='inside'
        closeOnOverlayClick={false}
        allowPinchZoom
      >
        <ModalOverlay />
        <ModalContent pb={2}>
          <ModalHeader>マルチクラウド障害通知システムのドキュメント一覧</ModalHeader>
          <ModalCloseButton />
            <ModalBody mx={6}>
              {dlFlag ? (
                <Center>
                  {executing ? (
                    <>
                    <Text>ダウンロード中です...</Text>
                    <Spinner color="teal.500" />
                    </>
                  ) : (
                    <Text>完了しました。</Text>
                  )}
                </Center>
              
              ) : docList && docList.cloudKindList.length === 0 ? (
                <Text>ドキュメントはありません。</Text>
                
              ) : docList && (
                <>
                <Text>{docList.message}</Text>
                {docList.cloudKindList.map((docKind:DocKindObj) => (
                  <Box key={docKind.cloudKindName}>
                    <Text marginTop="10px">【{docKind.cloudKindName}】</Text>
                    <Table size="xs" border="1px" borderColor="gray.300" colorScheme="gray" variant="striped">
                    <Tbody>
                      <Tr backgroundColor="#aaaaaa">
                        <Th color="white" paddingLeft="5px">ファイル名</Th>
                        <Th color="white" width="100px">更新日時</Th>
                      </Tr>
                      {docKind.documentList.map((docObj:DocObj) => (
                        <Tr key={docObj.documentId}>
                          <Td paddingLeft="5px"><Link color='teal.500' onClick={()=>dlDocument(docObj)}>{docObj.documentName}</Link></Td>
                          <Td>{docObj.updatedDate}</Td>
                        </Tr>
                      ))
                    }
                    </Tbody>
                    </Table>
                  </Box>
                ))}
                </>
              )}
            </ModalBody>
            
            <ModalFooter>
              {dlFlag ? (
                <PrimaryButton size="md" type="ng" onClick={()=>setDlFlag(false)} isLoading={executing}>閉じる</PrimaryButton>
              ) : (
                <PrimaryButton size="md" type="ng" onClick={closeDialog} isLoading={executing}>閉じる</PrimaryButton>
              )}
            </ModalFooter> 
        </ModalContent>
      </Modal>
    )}
    </>
  );
};
